import React from 'react';
import PropTypes from 'prop-types';
import { Form, Modal } from 'antd';
import { MyInput } from 'components/Atoms';
import { FormattedMessage, useIntl } from 'react-intl';

const ModalReason = ({
  visible,
  title,
  subTitle,
  confirmLoading,
  okText,
  cancelText,
  onOk,
  onCancel,
  reasonRequired,
}) => {
  const [form] = Form.useForm();

  const { formatMessage } = useIntl();

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const onFinish = (values) => {
    onOk(values, handleCancel);
  };

  return (
    <Modal
      visible={visible}
      onCancel={handleCancel}
      title={<FormattedMessage id={title} />}
      okText={<FormattedMessage id={okText} />}
      okButtonProps={{ className: 'ant-btn ant-btn-large site-button' }}
      cancelButtonProps={{
        className: 'ant-btn ant-btn-large site-button grey',
      }}
      cancelText={<FormattedMessage id={cancelText} />}
      confirmLoading={confirmLoading}
      onOk={form.submit}
      destroyOnClose
    >
      {subTitle && (
        <div className="subtitle mb-20">
          {<FormattedMessage id={subTitle} />}
        </div>
      )}
      <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item
          name="reason"
          label={<FormattedMessage id="common.reason" />}
          rules={[
            {
              required: reasonRequired,
              message: <FormattedMessage id="project.detail.require_reason" />,
            },
          ]}
        >
          <MyInput
            type="textarea"
            placeholder={formatMessage({ id: 'common.enter' })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

ModalReason.defaultProps = {
  visible: false,
  title: '',
  subTitle: '',
  confirmLoading: false,
  okText: '',
  cancelText: 'common.cancel',
  onOk: () => {},
  onCancel: () => {},
  reasonRequired: true,
};

ModalReason.propTypes = {
  visible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  confirmLoading: PropTypes.bool,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  reasonRequired: PropTypes.bool,
};

export default ModalReason;
